/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
// AFP-2532 TODO: Fix automatic suppressions below
import { FormStateChangeNotifier } from '../form';
import { FieldContainer } from '../../UIKit-legacy/utils/FieldContainer';
var AKRange = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.range' */
  '@atlaskit/range');
});
var AKField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var Range = function Range(_ref) {
  var defaultValue = _ref.defaultValue,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    label = _ref.label,
    name = _ref.name,
    testId = _ref.testId;
  return jsx(FieldContainer, null, jsx(AKField, {
    name: name,
    label: label,
    defaultValue: defaultValue || min
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps;
    var isDisabled = fieldProps.isDisabled,
      onChange = fieldProps.onChange,
      onBlur = fieldProps.onBlur,
      onFocus = fieldProps.onFocus,
      value = fieldProps.value,
      ariaLabelledBy = fieldProps['aria-labelledby'];
    return jsx(Fragment, null, jsx(FormStateChangeNotifier, {
      name: name,
      value: fieldProps.value
    }), jsx(AKRange, {
      min: min,
      max: max,
      step: step,
      testId: testId,
      isDisabled: isDisabled,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      "aria-labelledby": ariaLabelledBy
    }));
  }));
};
export default Range;
export var RangeFn = function RangeFn(_ref3) {
  var props = _ref3.props;
  return jsx(Range, props);
};